{
  "title": "Locate Object",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level divination",
  "level": 2,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a forked twig)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Describe or name an object that is familiar to you. You sense the direction to the object’s location, as long as that object is within 1,000 feet of you. If the object is in motion, you know the direction of its movement.",
    "The spell can locate a specific object known to you, as long as you have seen it up close – within 30 feet – at least once. Alternatively, the spell can locate the nearest object of a particular kind, such as a certain kind of apparel, jewelry, furniture, tool, or weapon.",
    "This spell can’t locate an object if any thickness of lead, even a thin sheet, blocks a direct path between you and the object."
  ],
  "spellLists": ["bard", "cleric", "druid", "paladin", "ranger", "wizard"]
}
